import { lazy, Suspense } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const TasksListPage = lazy(() => import("./TasksListPage"));
const TasksArchivePage = lazy(() => import("./TasksArchivePage"));
const TaskShowPage = lazy(() => import("./TaskShowPage"));
const TaskEditPage = lazy(() => import("./TaskEditPage"));

function listPage(path: string): RouteObject {
  return {
    path,
    element: (
      <Suspense fallback={<Loading />}>
        <TasksListPage />
      </Suspense>
    ),
  };
}

function archivePage(path: string): RouteObject {
  return {
    path,
    element: (
      <Suspense fallback={<Loading />}>
        <TasksArchivePage />
      </Suspense>
    ),
  };
}

const tasksRoutes: RouteObject[] = [
  listPage("/groups/:groupSlug/tasks"),
  listPage("/groups/:groupSlug/tasks/my"),
  listPage("/groups/:groupSlug/tasks/assigned"),
  listPage("/groups/:groupSlug/tasks/starred"),
  archivePage("/groups/:groupSlug/tasks/archive"),
  listPage("/tasks"),
  listPage("/tasks/my"),
  listPage("/tasks/assigned"),
  listPage("/tasks/starred"),
  listPage("/tasks/notes"),
  listPage("/tasks/declined"),
  archivePage("/tasks/archive"),
  {
    path: "/tasks/:id/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <TaskEditPage />
      </Suspense>
    ),
  },
  {
    path: "/tasks/:id",
    element: (
      <Suspense fallback={<Loading />}>
        <TaskShowPage />
      </Suspense>
    ),
  },
];

export default tasksRoutes;
